import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { ReactComponent as ChevronRightIcon } from "../../../assets/images/btn-right-aero.svg";

import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getExperience,
  getViewProfile,
  updateProfile,
} from "../../../redux/slices/profileSlice";
import { activityStart, activityEnd } from "../../../redux/slices/trackActivitySlice";

const YearsOfExperienceModal = ({
  show,
  onHide,
  onSave,
  shouldUpdateProfile = false,
  selectedExperience,
  isApplyPage = false,
}) => {
  const [localExperience, setLocalExperience] = useState(
    selectedExperience || "",
  );

  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);

  useEffect(() => {
    setLocalExperience(selectedExperience || "");
  }, [selectedExperience]);

  useEffect(() => {
    dispatch(getExperience());
  }, []);

  const experiences = [
    "New Graduate (0-1 year)",
    "Early Career (1-3 years)",
    "Experienced (3-7 years)",
    "Senior Level (7-15 years)",
    "Advanced Career (15+ years)",
    "Other",
  ];

  const handleSave = () => {
    if (localExperience) {
      onSave(localExperience);
      onHide();
    }
  };

  // const onSubmit = () => {
  //   const payload = {
  //     nursing_experiences_id: localExperience.id.toString(),
  //     name: store?.profileItem?.data?.full_name,
  //   };
  //   dispatch(updateProfile(payload));
  // };

  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      onHide();
      dispatch(getExperience());
    }
  }, [dispatch, onHide, store?.actionFlag]);

  useEffect(() => {
    if (!show) return;

    // Modal opened — start a tracking session
    dispatch(activityStart({ page_name: "CHANGE_YEARS_OF_EXPERIENCE", platform: "web" }));

    return () => {
      // Modal closed — end the session (duration recorded in seconds)
      dispatch(activityEnd({ page_name: "CHANGE_YEARS_OF_EXPERIENCE" }));
    };
  }, [show, dispatch]);

  useEffect(() => {
    if (show) {
      // dispatch(getViewProfile());
    }
  }, [show, dispatch]);
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">
          How many years of nursing experience do you have?
        </h5>
        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <div className="radio-options">
          <div className="row">
            {store?.experienceItems?.data?.nursing_experiences?.map((exp) => (
              <div
                key={exp.id}
                className={`radio-option col-lg-6 ${
                  localExperience?.id === exp.id ? "selected" : ""
                }`}
                onClick={() => setLocalExperience(exp)} // store full object
              >
                <div className="contentwrap">
                  <input
                    type="radio"
                    name="experienceLevel"
                    id={`experience-${exp.id}`} // unique id
                    value={exp.name}
                    checked={localExperience?.id === exp.id}
                    readOnly
                  />
                  <label
                    htmlFor={`experience-${exp.id}`}
                    className="radio-label"
                  >
                    {exp.name}
                  </label>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="buttons text-center">
          <Button
            className="next-btn"
            // onClick={() => {
            //   if (!localExperience) return;

            //   if (isApplyPage) {
            //     onSave(localExperience);
            //     onHide();
            //   } else {
            //     const payload = {
            //       nursing_experiences_id: localExperience.id.toString(),
            //       name: store?.profileItem?.data?.full_name,
            //     };

            //     dispatch(updateProfile(payload));
            //   }
            // }}
            onClick={() => {
              if (!localExperience) return;

              if (isApplyPage) {
                // ✅ always update local
                onSave(localExperience);

                // 🔥 ONLY call API if empty before
                if (shouldUpdateProfile) {
                  const payload = {
                    nursing_experiences_id: localExperience.id.toString(),
                    name: store?.profileItem?.data?.full_name,
                  };

                  dispatch(updateProfile(payload));
                }

                onHide();
              } else {
                // ✅ Profile page → always API
                const payload = {
                  nursing_experiences_id: localExperience.id.toString(),
                  name: store?.profileItem?.data?.full_name,
                };

                dispatch(updateProfile(payload));
              }
            }}
            disabled={store?.isLoading || !localExperience}
          >
            {store?.isLoading ? "Saving..." : "Save"}{" "}
            <ChevronRightIcon className="button-icon" />
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default YearsOfExperienceModal;
